/**
 * @fileoverview > handler for the "/engagement/canvas_steps/:workflow_id/:app_group_id" endpoint
 * @note this is a POST request because we attach the steps ids to the payload in order
 *   to optimize the loading of steps due to the occassionally oversized nature of their
 *   message payloads
 * @todo this should be made a GET
 */

import type { CanvasStepDocument } from "@dashboardApi/apis/canvas/common";

import { fetchStepData } from "@lib/canvas/fetchStepData";

import { reactQueryMutationAdapter } from "../../reactQueryFetcherAdapters";
import { engagementCanvasStepsWorkflowIdAppGroupIdCacheKeys } from "./constants";
import type { CanvasStepMetadataDocument, PostEngagementCanvasStepsWorkflowIdAppGroupIdProps } from "./types";

/** a method to get the specified canvas steps for a given canvas. internally chunks out requests */
export const getCanvasStepsPost = reactQueryMutationAdapter(
  engagementCanvasStepsWorkflowIdAppGroupIdCacheKeys,
  (props: PostEngagementCanvasStepsWorkflowIdAppGroupIdProps): Promise<CanvasStepDocument[]> => {
    return fetchStepData(undefined, {
      workflowId: props.canvasId,
      appGroupId: props.appGroupId,
      stepIds: props.stepIds,
      viewActiveCanvas: props.viewActiveCanvas,
    });
  }
);

/** Gets the minimal Canvas step fields needed by Engagement Reports. */
export const getCanvasStepMetadataPost = reactQueryMutationAdapter(
  engagementCanvasStepsWorkflowIdAppGroupIdCacheKeys,
  (props: PostEngagementCanvasStepsWorkflowIdAppGroupIdProps): Promise<CanvasStepMetadataDocument[]> => {
    return fetchStepData<CanvasStepMetadataDocument>(undefined, {
      workflowId: props.canvasId,
      appGroupId: props.appGroupId,
      stepIds: props.stepIds,
      viewActiveCanvas: props.viewActiveCanvas,
      lightweight: true,
    });
  }
);
